import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { URL_DOCS } from 'src/app/config/config';

@Component({
  selector: 'app-benefits',
  templateUrl: './benefits.component.html',
  styleUrls: ['./benefits.component.css']
})
export class BenefitsComponent implements OnInit {
  URL_DOCS = URL_DOCS;

  isDashboard: boolean = false;
  showAll: boolean = false;
  maxItems: number =4; 
  minItems: number =2; 
  searchText: string = '';


  constructor(private router: Router) { }
  @Input() benefits: any[] = [];
  ngOnInit(): void {
    this.checkRoute();
    this.updateMaxItems();

  }
  
  checkRoute(): void {
    const currentRoute = this.router.url;
    
    // Verifica si la ruta es '/dashboard'
    if (currentRoute.includes('/dashboard')) {
      this.isDashboard = true;
    } else {
      this.isDashboard = false;
    }
  }


  
    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
      this.updateMaxItems();
    }
  
    updateMaxItems() {
      this.maxItems = window.innerWidth <= 768 ? 2 : 4; // Móvil: 2, Escritorio: 4
    }
  
  handleButtonClick(){
    if(this.isDashboard){
      this.router.navigate(['/otras-prestraciones']);
    }else{
      this.showAll = !this.showAll;
    }
  }

}
